import { render, staticRenderFns } from "./LacakSn.vue?vue&type=template&id=88933202&scoped=true&"
import script from "./LacakSn.vue?vue&type=script&lang=js&"
export * from "./LacakSn.vue?vue&type=script&lang=js&"
import style0 from "./LacakSn.vue?vue&type=style&index=0&id=88933202&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88933202",
  null
  
)

export default component.exports